import { useLayoutEffect, useState, type RefObject } from "react";

export function analysisChartCapacity(viewportBottom: number, rowsTop: number, rowHeight: number, reserved: number) {
  return Math.max(1, Math.min(50, Math.floor((viewportBottom - rowsTop - reserved) / Math.max(1, rowHeight))));
}
/** Measure the available viewport, not a fixed number of records per page. */
export function useAnalysisChartCapacity(ref: RefObject<HTMLUListElement | null>, fallback: number, reserved: number, active = true) {
  const [capacity, setCapacity] = useState(fallback);
  useLayoutEffect(() => {
    const rows = ref.current;
    if (!rows || !active) return;
    const panel = rows.closest(".pa-presentation-panel");
    const track = rows.closest(".pa-presentation-track");
    const measure = () => {
      if (!window.matchMedia("(min-width: 1000px) and (min-height: 650px)").matches) { setCapacity(fallback); return; }
      const top = rows.getBoundingClientRect().top;
      if (top < 0 || top >= window.innerHeight) return;
      const height = Math.max(1, ...Array.from(rows.children, row => row.getBoundingClientRect().height));
      const viewport = rows.closest('.pa-presentation[data-detail="false"] .pa-presentation-scroll');
      const bottom = Math.min(window.innerHeight, viewport?.getBoundingClientRect().bottom ?? window.innerHeight);
      setCapacity(analysisChartCapacity(bottom, top, height, reserved));
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(rows);
    if (panel) observer.observe(panel);
    window.addEventListener("resize", measure);
    track?.addEventListener("transitionend", measure);
    return () => { observer.disconnect(); window.removeEventListener("resize", measure); track?.removeEventListener("transitionend", measure); };
  }, [ref, fallback, reserved, active]);
  return capacity;
}
